module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Tendance.a8bc2dd7-ps.jpg";